import { groupByDateAsArray } from './_log_tool.js';
import { createShopifyClient } from '../dictionary/_shopifyItems.js';
import { createProductsClient } from '../dictionary/_shopifyProducts.js';
export let getVisited = {
	arry: [],
	target: null,
	load: async function(){
		getVisited.target = document.querySelector(`#page_content .c-list_index .list_index`);
		//console.log(getVisited.target);
		if( getVisited.target ){
			const itemsClient = createShopifyClient({ shop: '0tgpcj-k6' });
			const productsClient = createProductsClient({ shop: '0tgpcj-k6' });
			
			const items = await itemsClient.fetchAllItems({ pageSize: 200 });
			const products = await productsClient.fetchAllProducts({ pageSize: 200 });
			products.forEach( (p) => {
				p.initials = p.title.charAt(0);
				//console.log(p.initials)
			});
			const merged = [...items, ...products];
			const sorted = merged.sort((a, b) => {
				const aIni = (a.initials || "").trim().toLowerCase();
				const bIni = (b.initials || "").trim().toLowerCase();
				
				// 数字判定（先頭文字が 0-9 かどうか）
				const aIsNum = /^[0-9]/.test(aIni);
				const bIsNum = /^[0-9]/.test(bIni);
				
				// 数字は後ろに送りたい
				if (aIsNum && !bIsNum) return 1;
				if (!aIsNum && bIsNum) return -1;
				
				// どちらも同じカテゴリなら英語順比較
				return aIni.localeCompare(bIni, "en");
			});
			getVisited.arry = sorted;
			this.makeHTML();
		}
	},
	makeHTML: function(){
		let HTML = ``;
		let beforeIni = "";
		let count = 0;
		getVisited.arry.forEach( (a, index) => {
			//console.log(a);
			if( a.initials != "" ){
				if( beforeIni != a.initials ){
					count = 0;
				}
				let cat = "";
				if(a.category){
					cat = "c-" + a.category.slug;
				}
				
				let nextItem = getVisited.arry[index + 1];
				let isLast = "";
				if( nextItem ){
					let nextInitial = nextItem.initials;
					if( nextInitial != a.initials ){
						isLast = "ini_last";
					}
				}
				let url = a.url.replace(/^https?:\/\/[^/]+/, "");
				if( url.includes("/products/") ){
					//console.log(a);
					HTML += `
							<p class="initial${count} ${isLast}" data-initial="${a.initials}">
								<a class="${cat}" href="${url}">
									<span class="ja"><span class="t">${a.title} ${a.title_ja}</span></span>
									
								</a>
							</p>
							`;
					//console.log("products:", a.title_ja, a.initials)
				}else{
					HTML += `
							<p class="initial${count} ${isLast}" data-initial="${a.initials}">
								<a class="${cat}" href="${url}">
									<span class="ja"><span class="t">${a.title_ja}</span></span>
									<span class="en"><span class="t">${a.title_en}</span></span>
								</a>
							</p>
							`;
				}
				
				count++;
				beforeIni = a.initials;
			}
		});
		document.querySelector(".c-list_index .list_index").innerHTML = HTML;
		getVisited.check();
		setTimeout(function(){
			getVisited.check();
		}, 600);
	},
	check: function(){
		let $target = document.querySelector(`.c-list_index`);
		if( $target ){
			//const raw = localStorage.getItem("item.visited");
			let raw = localStorage.getItem("pjax.visit.log");
			if (raw) {
				const parsed = JSON.parse(raw);
				console.log("daily visited log:", parsed);
				const todayStr = new Date().toISOString().split("T")[0];
				
				// 本日分だけフィルタ
				const todaysData = parsed.filter(item => {
					const itemDate = new Date(item.ts).toISOString().split("T")[0];
					return itemDate === todayStr;
				});
				//console.log(todaysData);
				/*
				f (Array.isArray(parsed)) entries = parsed;
				let history = groupByDateAsArray(parsed);
				const allItems = history.flatMap(entry => entry.items);
				// URL をキーにして重複を取り除く
				const uniqueItems = Array.from(
					new Map(allItems.map(item => [item.url, item])).values()
				);
				*/
				todaysData.forEach( ( item ) => {
					item.url = item.url.replace(/^https?:\/\/[^/]+/, "");
				});
				//console.log(parsed.entries);
				getVisited.addVisited(todaysData);
			}
		}
	},
	addVisited: function( items ){
		console.log(items);
		let $lists = document.querySelectorAll(".c-list_index .list_index a");
		/*
		items.forEach( ( item, idx ) => {
			console.log("addVisited:", item.url)
		});
		*/
		$lists.forEach( ( list, index ) => {
			let link = list.getAttribute("href");
			items.forEach( ( item, idx ) => {
				if( link === item.url ){
					list.classList.add("visited");
				}
			});
		});
	}
}
